import { useTranslation } from 'react-i18next';

import { Checkbox } from '@/components/ui/checkbox';
import type { HistoryFilters as HistoryFiltersType } from '../model';

interface HistoryFiltersProps {
  filters: HistoryFiltersType;
  onFilterChange: (filterName: keyof HistoryFiltersType, value: boolean) => void;
}

export function HistoryFilters({ filters, onFilterChange }: HistoryFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-8">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="show-status"
          checked={filters.showStatus}
          onCheckedChange={(checked: boolean) => onFilterChange('showStatus', checked)}
        />
        <label
          htmlFor="show-status"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {t('newcmr.history.status.label')}
        </label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="show-priority"
          checked={filters.showPriority}
          onCheckedChange={(checked: boolean) => onFilterChange('showPriority', checked)}
        />
        <label
          htmlFor="show-priority"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {t('newcmr.history.priority.label')}
        </label>
      </div>
    </div>
  );
}
